<template>
    <b-form-group :label="$t(placeholder)">
        <treeselect
            v-if="isChemity"
            :title="$t('Component(BusinessRoles):hover-instruction')"
            @input="onChange"
            :multiple="true"
            :options="options"
            noChildrenText=""
            :normalizer="normalize"
            :disableBranchNodes="true"
            valueFormat="object"
            v-model="value"
        />
        <v-select
            v-else
            v-model="value"
            label="title"
            multiple
            :placeholder="$t('Component(BusinessRoles):hover-instruction')"
            @input="onChange"
            :options="options"
        />
    </b-form-group>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import Treeselect from '@riophae/vue-treeselect'
import {SupplyChain} from '@core/api'
import {isChemity} from "@/libs/application";
import vSelect from 'vue-select'

export default {
    components: {
        Treeselect,
        BFormGroup,
        vSelect
    },

    props: {
        placeholder: {
            type: String,
            default: 'Component(BusinessRoles):label'
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            options: [],
            value: this.selected,
            isChemity: isChemity(),

            chemityValue: [],
        };
    },

    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },
        onChange(value) {
            if (this.isChemity) {
                this.$emit('change', value);
            } else {
                this.$emit('change', this.value.concat(this.chemityValue));
            }
        },
    },

    watch: {
        selected(value) {
            if (this.isChemity) {
                this.value = value;
            } else {
                this.value = value.filter(v => this.options.find(o => o.id === v.id));
                this.chemityValue = value.filter(v => !this.options.find(o => o.id === v.id));
            }
        }
    },

    created() {
        SupplyChain.getBusinessRoles().then(r => this.options = r.data);
    }
};
</script>
<style lang="css">
@import '../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
